import { fork } from 'redux-saga/effects';
import watchUserActionsSaga from './users/userSaga.ts';
import { watchUserManagement } from './userManagement/userManagementSaga.ts';
import watchAllScenarioSagas from './scenarios/scenarioSaga.ts';
import watchAllIntentsSaga from './scenarios/intentSaga.ts';
import watchAllIntentEditingSaga from './scenarios/intentEditingSaga.ts';
import { watchScenarioChartEditing } from './scenarios/scenarioChartEditingSaga.ts';
import watchAllAudiosSaga from './audio/audioSaga.ts';
import { watchAllDPResponseSaga } from './dialogProcessor/dialogProcessorSaga.ts';
import { watchCompanyManagement } from './companyManagment/companyManagementSaga.ts';
import watchAllDashboardsSaga from './dashboard/dashboardSaga.ts';
import watchAllStatisticSaga from './statistic/statisticSaga.ts';
import watchSpeechToTextSaga from './speechToText/speechToTextSaga.ts';
import groupManagementSaga from 'app/components/GroupManagement/store/groupManagementSaga.ts';
import courseManagementSaga from 'app/components/CourseManagement/store/courseManagementSaga.ts';
import globalAssetsLibrarySaga from 'app/store/GlobalAssetsLibrary/globalAssetsLibrarySaga.ts';
import { departmentSaga } from './departmentSaga.ts';
import translatorSaga from 'app/components/Translator/store/translatorSaga.ts';
import audioChatSaga from 'app/store/AudioChat/audioChatSaga.ts';

export default function* rootSaga() {
  yield fork(watchScenarioChartEditing);
  yield fork(watchUserActionsSaga);
  yield fork(watchUserManagement);
  yield fork(watchAllScenarioSagas);
  yield fork(watchAllIntentsSaga);
  yield fork(watchAllIntentEditingSaga);
  yield fork(watchAllAudiosSaga);
  yield fork(watchAllDPResponseSaga);
  yield fork(watchCompanyManagement);
  yield fork(watchAllDashboardsSaga);
  yield fork(watchAllStatisticSaga);
  yield fork(watchSpeechToTextSaga);
  yield fork(groupManagementSaga);
  yield fork(courseManagementSaga);
  yield fork(globalAssetsLibrarySaga);
  yield fork(departmentSaga);
  yield fork(translatorSaga);
  yield fork(audioChatSaga);
}
